import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getCountryCallingCode } from 'libphonenumber-js/min';
import { FlagIcon } from './country-flags';
import styles from './styles.module.scss';
export var CountryOption = function (_a) {
    var country = _a.country, showName = _a.showName;
    return (_jsxs("div", { className: styles['country-option'], children: [_jsx(FlagIcon, { countryCode: country.code, className: styles.flag, "aria-label": country.name }), _jsxs("span", { className: styles['country-code'], children: ["+", getCountryCallingCode(country.code)] }), showName && _jsx("span", { className: styles['country-name-mobile'], children: country.name })] }));
};
